import BusinessTransactionsCountCard from "~/components/Metrics/BusinessTransactionsCountCard";
import api from "~/api";
import { useTranslation } from "react-i18next";

const BusinessTransactionsCount = ({ posId }: { posId: string }) => {
  const { t } = useTranslation();
  const getBusinessTransactionsMetrics = async (
    params: MetricsAPI.GetBusinessTransactionsQuery
  ) => {
    try {
      const { data } = await api.metrics.getBusinessTransactionsCountByPOS({
        ...params,
        posId,
      });
      if (data) {
        return data.data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <BusinessTransactionsCountCard
      title={`${t("title.businessTransactionCountsBy")} POS: ${posId}`}
      onUpdate={getBusinessTransactionsMetrics}
    />
  );
};

export default BusinessTransactionsCount;
